export const getNetLikesColor = (netLikes: number): string => {
  if (netLikes > 0) {
    return "text-green-500";
  }
  if (netLikes < 0) {
    return "text-red-500";
  }
  return "text-default-400";
};
